import { themeVars, toBorder } from '@tundr/theme';
import { globalStyle, style } from '@vanilla-extract/css';

globalStyle('input[type="checkbox"]', {
  WebkitAppearance: 'none',
  appearance: 'none',
  margin: 0,
  font: 'inherit',
  color: 'currentcolor',
  minWidth: 23,
  height: 23,
  borderRadius: themeVars.radius.sm,
  transform: 'translateY(-1px)',
  display: 'grid',
  placeContent: 'center',
  cursor: 'pointer',
  overflow: 'hidden',
  transition: themeVars.transitions.default,
  border: toBorder(themeVars.colors.components.checkbox.default.border),
});

globalStyle('input[type="checkbox"]:checked', {
  backgroundColor: themeVars.colors.components.checkbox.checked.background,
  color: themeVars.colors.components.checkbox.checked.color,
  border: 'none',
});

globalStyle('input[type="checkbox"]::before', {
  position: 'absolute',
  content: '',
  left: 0,
  top: 0,
});

globalStyle('input[type="checkbox"]::after', {
  position: 'absolute',
  left: 2,
  top: 2,
  content: '',
  width: '.88em',
  height: '.45em',
  border: `.13em solid ${themeVars.colors.components.checkbox.checked.color}`,
  transform: 'translate(.2em, .3em) rotate(-45deg)',
  borderTopStyle: 'none',
  borderRightStyle: 'none',
});

export const checkboxWrapperClass = style({
  display: 'flex',
  alignItems: 'flex-start',
  cursor: 'pointer',
  gap: themeVars.space.x3,
});

export const checkboxElementClass = style({
  marginTop: themeVars.space.x1,
});

export const checkboxLabelClass = style({
  cursor: 'pointer',
  fontSize: themeVars.font.size.textMd,
  textAlign: 'left',
});
